import { AuthSessionStore } from "../auth_session.js";
import { StatisticsStorage } from "../../storage/statistics_storage.js";

// PicPix's leaderboard code reads the current player from AuthSessionStore.getUser()
// (a full PlayerDto with content_mode / level / nickname / avatar / fb url).
// BrickBreaker's AuthSessionStore only keeps id + token, so this helper assembles
// the same shape from BrickBreaker's own sources (auth session + statistics +
// locally-stored profile bits). BrickBreaker has no content modes → always "0".
export interface LeaderboardPlayer
{
  id: string;
  content_mode: string;
  level: number;
  nickname: string;
  avatar_id: number;
  facebook_avatar_url: string | null;
}

export const LEADERBOARD_CONTENT_MODE = "0";

export function getLeaderboardPlayer(): LeaderboardPlayer | null
{
  const id = AuthSessionStore.getPlayerId();
  if ( id === null ) return null;

  const avatar_raw = localStorage.getItem( "player_avatar_id" );
  const avatar_id = avatar_raw ? ( parseInt( avatar_raw, 10 ) || 0 ) : 0;

  return {
    id: String( id ),
    content_mode: LEADERBOARD_CONTENT_MODE,
    level: StatisticsStorage.load().level,
    nickname: localStorage.getItem( "player_nickname" ) ?? "",
    avatar_id,
    facebook_avatar_url: localStorage.getItem( "player_facebook_avatar_url" ),
  };
}

export function getLeaderboardCurrentUserId(): string
{
  const id = AuthSessionStore.getPlayerId();
  return id === null ? "" : String( id );
}
